@let isExpandedValue = panelState.isExpanded();
@let isFullScreenValue = panelState.isFullScreen();
@let headerTitleValue = headerTitle();
@let candidateValue = candidate();
@let availableOffersValue = availableOffers();
@let dataValue = data();

<div
  class="panel"
  [class.panel--expanded]="isExpandedValue"
  [class.panel--fullscreen]="isFullScreenValue"
>
  <rt-evaluation-panel-header
    cdkDragHandle
    [title]="headerTitleValue!"
    [isExpanded]="isExpandedValue"
    [isFullScreenMode]="isFullScreenValue"
    (expand)="panelState.toggleExpanded()"
    (fullscreen)="panelState.toggleFullScreen()"
    (close)="onCancel()"
  />

  @if (isExpandedValue) {
    <div
      class="panel__body"
      [class.panel__body--scroll-locked]="templateForm()?.commentTooltipOpen()"
    >
      @if (!candidateValue || showSkeleton()) {
        <rt-evaluation-panel-skeleton />
      } @else if (dataValue.quickEvaluation) {
        <rt-quick-evaluation-form
          [offers]="availableOffersValue"
          [preselectedOfferId]="quickPreselectedOfferId()"
          [placements]="candidateValue.placements"
          [ratingScale]="ratingScale()"
        />
      } @else {
        <rt-template-evaluation-form
          [infoTitle]="templateInfo().title"
          [infoDescription]="templateInfo().description"
          [attachmentsByAnswerId]="attachmentsByAnswerId()"
          [ratingScale]="ratingScale()"
        />
      }
    </div>

    @if (candidateValue && !showSkeleton()) {
      <rt-evaluation-panel-footer
        [isLoading]="isSubmitting()"
        [isSubmitDisabled]="attachmentsUploading()"
        [hasAutoSaveInfo]="draftSaved()"
        [submitLabelKey]="submitLabelKey()"
        (cancel)="onCancel()"
        (clearForm)="onClearForm()"
        (submit)="onSubmit()"
      />
    }
  }
</div>
